import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { AssetSubTypeApi } from '../api/assetSubType.api';
import { switchMap, map } from 'rxjs/operators';

import { AssetSubTypeData, AssetSubType } from '../../../interfaces/masters/assetSubType' ;
@Injectable()
export class AssetSubTypeService extends AssetSubTypeData {

    constructor(private api: AssetSubTypeApi) {
      super();
    }
  
  
    list(url: string): Observable<AssetSubType[]> {
      return this.api.list(url);
    }
  
    getById(url:string): Observable<AssetSubType>{
        return this.api.getById(url);
    }
  
    create(url: string, data:AssetSubType): Observable<AssetSubType[]> {
      debugger;
      return this.api.add(url,data);
    }
  
    update(url: string, data:AssetSubType): Observable<AssetSubType> {
      return this.api.update(url,data);
    }
  
    
  
    delete(url: string): Observable<boolean> {
      return this.api.delete(url);
    }
  }
  